import _classCallCheck from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { duplicate, hash as _hash } from '../../util';
import { DataFlowNode } from './dataflow';
/**
 * A class for flatten transform nodes
 */

export var FoldTransformNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(FoldTransformNode, _DataFlowNode);

  function FoldTransformNode(parent, transform) {
    var _this;

    _classCallCheck(this, FoldTransformNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FoldTransformNode).call(this, parent));
    _this.transform = transform;
    _this.transform = duplicate(transform); // duplicate to prevent side effects

    var specifiedAs = _this.transform.as || [undefined, undefined];
    _this.transform.as = [specifiedAs[0] || 'key', specifiedAs[1] || 'value'];
    return _this;
  }

  _createClass(FoldTransformNode, [{
    key: "clone",
    value: function clone() {
      return new FoldTransformNode(null, duplicate(this.transform));
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(this.transform.as);
    }
  }, {
    key: "hash",
    value: function hash() {
      return "FoldTransform ".concat(_hash(this.transform));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var _this$transform = this.transform,
          fold = _this$transform.fold,
          as = _this$transform.as;
      var result = {
        type: 'fold',
        fields: fold,
        as: as
      };
      return result;
    }
  }]);

  return FoldTransformNode;
}(DataFlowNode);